// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import GridContainer from "@insite/mobius/GridContainer";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import setNotify from "@store/Framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetNotify";
import { orderTotalProps } from "@store/Themes/common/props/checkout";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const session = getSession(state);

    return {
        isLoading: cartState.isLoading,
        cart: cartState.value,
        notifyStoreManager: state.store.pages.checkoutReviewAndSubmit.notifyStoreManager,
        canNotify: (session.userRoles || "").indexOf("CanNotifyStoreManager") !== -1,
    };
};

const mapDispatchToProps = {
    setNotify,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CheckoutReviewAndSubmitNotifyStoreManagerStyles {
    container?: GridContainerProps;
    checkboxGridItem?: GridItemProps;
    checkbox?: CheckboxPresentationProps;
}

export const notifyStoreManagerStyles: CheckoutReviewAndSubmitNotifyStoreManagerStyles = {
    container: orderTotalProps.container,
    checkboxGridItem: { width: 12 },
};

const styles = notifyStoreManagerStyles;

const CheckoutReviewAndSubmitNotifyStoreManager: FC<Props> = ({
    isLoading,
    cart,
    notifyStoreManager,
    canNotify,
    setNotify,
}) => {
    if (!canNotify) {
        return <></>;
    }

    const notifyChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        if (cart) {
            setNotify({ notifyStoreManager: value });
        }
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.checkboxGridItem}>
                <Checkbox onChange={notifyChangeHandler} checked={notifyStoreManager} disabled={isLoading}>
                    {translate("Notify Store Manager")}
                </Checkbox>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CheckoutReviewAndSubmitNotifyStoreManager),
    definition: {
        group: "Checkout - Review & Submit",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        displayName: "Notify Store Manager",
    },
};

export default widgetModule;
